var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIocn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8031 1.19682C15.2071 -0.399001 12.6195 -0.398933 11.0237 1.19699L2.21664 10.0048C1.75261 10.4689 1.42646 11.0525 1.27446 11.6908L0.0232989 16.9452C-0.0455864 17.2346 0.0405545 17.5389 0.250865 17.7491C0.461186 17.9595 0.765551 18.0456 1.05489 17.9767L6.3095 16.7258C6.94811 16.5737 7.53199 16.2474 7.99615 15.7832L16.8032 6.97537C18.3989 5.37959 18.3989 2.7925 16.8031 1.19682ZM12.235 2.40807C13.1619 1.48114 14.6648 1.48109 15.5918 2.40798C16.5186 3.33478 16.5188 4.83742 15.5919 5.76428L14.574 6.78222L11.2173 3.42581L12.235 2.40807ZM10.0061 4.63704L13.3628 7.99345L6.78481 14.5722C6.54482 14.8122 6.24292 14.9808 5.91274 15.0595L2.01209 15.9881L2.94087 12.0876C3.01945 11.7575 3.18808 11.4558 3.42798 11.2159L10.0061 4.63704Z",
    fill: "#636E72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIocn);
export default __webpack_public_path__ + "static/media/edit_iocn.8fed44120fe2e649b1daf425acd382ff.svg";
export { ForwardRef as ReactComponent };